import moment from 'moment';
import takeWhile from '../../shared/takeWhile';
import range from '../../shared/arrayRange';

let last = array => array[array.length - 1];

export default function createDateObjects(date) {
    var date = moment(date);
    const startOfMonth = date.startOf('month');

    let diff = startOfMonth.weekday();
    if (diff < 0) diff += 7;

    const prevMonthDays = range(0, diff)
        .map(n => ({
            day: startOfMonth.clone().subtract(diff - n, 'days'),
            classNames: 'prev-month',
            styles: {color: '#999'}
        }));

    const currentMonthDays = range(1, date.daysInMonth() + 1)
            .map(index => ({
            day: moment([date.year(), date.month(), index]),
            classNames: '',
            styles: {}
        }));

    const daysAdded = prevMonthDays.length + currentMonthDays.length - 1;

    const nextMonthDays = takeWhile(range(1, 7), n => (daysAdded + n) % 7 !== 0)
        .map(n => ({
            day: last(currentMonthDays).day.clone().add(n, 'days'),
            classNames: 'next-month',
            styles: {color: '#999'}
        }));

    return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
}


// WEBPACK FOOTER //
// ./app/b3/date-picker/makeDatesForMonth.js